export default "__VITE_ASSET__a592a2ba__"